module.exports = __webpack_public_path__ + "img/05.5884d5d2.jpg";